export const LATEST_SECTION_ID = 'latest';
export const LATEST_SECTION_HASH = `#${LATEST_SECTION_ID}`;
export const LATEST_SECTION_HREF = `/${LATEST_SECTION_HASH}`;

export function normalizeSiteHref(href) {
  if (!href) {
    return href;
  }

  if (href === '/resources' || href === '#resources-grid' || href.startsWith('/resources#')) {
    return LATEST_SECTION_HREF;
  }

  return href;
}
